import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@siat-fe/env';
import { Observable } from 'rxjs';
import { IndirizzoDto } from '../models/indirizzo-dto.model';

@Injectable()
export class IndirizzoAutocompleteService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.baseUrl;

  autocomplete(query: string): Observable<IndirizzoDto[]> {
    const reqUrl = `${this.baseUrl}v1/geoutils/autocomplete`;
    const params = new HttpParams()
      .set('query', query)
    return this.httpClient.get<IndirizzoDto[]>(reqUrl, { params });
  }
}
